module.exports = __webpack_public_path__ + "static/media/exo-latin-200.6ecb520b.woff";